"use client"

import dynamic from "next/dynamic"
import type { ReactNode } from "react"

import { CartProvider } from "@context/cart-context"
import { CartDrawerProvider } from "@context/cart-drawer-context"
import { AnalyticsProvider } from "@context/analytics-context"
import { PaymentMethodsProvider } from "@context/payment-methods-context"
import type { AnalyticsConfig } from "@lib/data/analytics"
import type { PaymentMethodsContextValue } from "@context/payment-methods-context"

const CartDrawer = dynamic(() => import("@modules/layout/components/cart-drawer"), {
  ssr: false,
})

type ProvidersProps = {
  children: ReactNode
  analyticsConfig: AnalyticsConfig | null
  paymentMethodsConfig: PaymentMethodsContextValue
}

export default function Providers({
  children,
  analyticsConfig,
  paymentMethodsConfig,
}: ProvidersProps) {
  return (
    <AnalyticsProvider
      measurementId={analyticsConfig?.measurementId}
      metaPixelId={analyticsConfig?.metaPixelId}
      metaConversionsApiEnabled={analyticsConfig?.metaConversionsApiEnabled}
    >
      <PaymentMethodsProvider initialValue={paymentMethodsConfig}>
        <CartProvider>
          <CartDrawerProvider>
            <CartDrawer />
            {children}
          </CartDrawerProvider>
        </CartProvider>
      </PaymentMethodsProvider>
    </AnalyticsProvider>
  )
}
